import { j as n } from "../jsx-runtime-Wav_3Wde.js";
import { styled as o } from "styled-components";
const s = /* @__PURE__ */ o.a.withConfig({
  componentId: "sc-a3260283-0"
})([
  "",
  ""
], ({ theme: t }) => t.components.skipLink.base), a = ({ href: t, ...i }) => /* @__PURE__ */ n.jsx(s, {
  "data-qa-id": "skip-link",
  href: t,
  ...i,
  children: "Skip to content"
});
export {
  a as default
};
